import { render, staticRenderFns } from "./PlatformPermissions.vue?vue&type=template&id=455c2bc2"
import script from "./PlatformPermissions.vue?vue&type=script&lang=js"
export * from "./PlatformPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports